export default __webpack_public_path__ + "static/media/0008.0ba952e4.jpg";